module.exports = {
  LP_URL: "https://www.lonelyplanet.com",
  LP_SHOP_URL: "https://shop.lonelyplanet.com",
  LP_INSTAGRAM_URL: "https://instagram.com/lonelyplanet",
};
